'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import StoredContentContainer from '../../containers/StoredContentContainer';
import { LearningContentContainer } from '../../features/learningContent';

const TrackExamPage = ({
  track,
  onAdvanceContent,
  contentId
}) => /*#__PURE__*/_jsx(LearningContentContainer, {
  contentId: contentId,
  trackId: track.get('id'),
  children: /*#__PURE__*/_jsx(StoredContentContainer, {
    contentId: contentId,
    isParentGraded: true,
    onFinish: onAdvanceContent,
    trackId: track.get('id'),
    trackName: track.get('name')
  })
});

TrackExamPage.propTypes = {
  contentId: PropTypes.string.isRequired,
  onAdvanceContent: PropTypes.func.isRequired,
  track: ImmutablePropTypes.map.isRequired
};
export default TrackExamPage;